<template>
  <click-to-edit
    :disabled="!isFieldAvailableForEdit(scope.row, 'scale.max')"
    v-model="scope.row.scale.max"
    @input="saveElementPropChange(scope.row, 'scale', {max:$event})"
  ></click-to-edit>
</template>

<script>

import ClickToEdit from "@/components/ClickToEdit";
import {ElementPropTableColumn} from "@/mixins/elementPropTableColumn";

export default {
  name: 'element-configurable-scale-max-table-column',
  mixins: [ElementPropTableColumn],
  components: {ClickToEdit},

  props: {},
  data() {
    return {

    }
  },
  computed: {},
  methods: {}
}

</script>

<style>

</style>
